import { SxProps, Typography, TypographyProps } from '@mui/material';
import { useAccessibility } from '../../../Store/contexts/AccessibilityContext';

interface Props extends TypographyProps {
  text: string;
  alignCenter?: boolean;
  bold?: boolean;
}

const DefaultText: React.FC<Props> = ({ text, alignCenter, bold, ...typographyProps }) => {

  const sxStyle: SxProps = {
    fontFamily: "Unimed-Sans",
    fontSize: "16px",
    lineHeight: "30px",
    letterSpacing: "0em",
    ...(bold && { fontWeight: "bold" }),
    textAlign: alignCenter ? "center" : "left",
    color: "#4C4C4C",
    textWrap: 'wrap',
    '@media(max-width: 799px)': {
      width: '100%'
    }
  }

  const accessibility = useAccessibility();

  return (
    <Typography
      sx={sxStyle}
      style={accessibility.textStyleAccessibility}
      dangerouslySetInnerHTML={{ __html: text }}
      {...typographyProps}
    />
  )
}

export default DefaultText;